import { ImageT } from '@lambda/apis/src/catalog-v2/types';
import classNames from 'classnames';

type MobileNavigationProps = {
  images: ImageT[];
  selectedImage: number;
  setSelectedImage: React.Dispatch<React.SetStateAction<number>>;
};

const MobileNavigation = ({
  images,
  selectedImage,
  setSelectedImage,
}: MobileNavigationProps) => {
  if (images.length <= 1) {
    return null;
  }

  return (
    <div className="mx-auto mt-2 flex items-center justify-center gap-x-2 lg:hidden">
      {images.map((_image, i) => (
        <button
          aria-label={`Go to image ${i + 1}`}
          onClick={() => setSelectedImage(i)}
          key={i}
          className={classNames(
            'h-2.5 w-2.5 rounded-full border transition duration-150 ease-in-out focus:outline-none',
            {
              'border-gray-700 hover:bg-gray-700': selectedImage !== i,
              'border-gray-700 bg-gray-700': selectedImage === i,
            },
          )}
        />
      ))}
    </div>
  );
};

export default MobileNavigation;
